// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { getUserProfileMain } from "./actions/get-user-profile-main.action";
import { getUserProfileMedia } from "./actions/get-user-profile-media.action";

// ############################################################

// Initial state
const initialState = {
	gallery: {
		loading: false,
		loaded: true,
		data: [],
	},
	media: {
		loading: false,
		loaded: false,
		total: 0,
		data: [],
		pagination: {
			totalPages: 1,
			currentPage: 1,
		},
		hash: "",
	},
};

// ############################################################

// Slice
const userProfileMainContentSlice = createSlice({
	name: "user-profile/main-content",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getUserProfileMain.pending, (state) => {
			state.gallery.loading = true;
			state.gallery.loaded = false;
			state.media.loading = true;
			state.media.loaded = false;
			state.gallery.data = [];
			state.media.total = 0;
			state.media.data = [];
			state.media.pagination = {
				totalPages: 1,
				currentPage: 1,
			};
			state.media.hash = "";
		});
		builder.addCase(getUserProfileMain.fulfilled, (state, action) => {
			state.gallery.loading = false;
			state.gallery.loaded = true;
			state.media.loading = false;
			state.media.loaded = true;

			const { gallery, media } = action.payload || {};

			state.gallery.data = gallery;
			state.media.total = media?.total ?? 0;
			state.media.data = media?.media || [];
			state.media.pagination = {
				totalPages: media?.pagination?.totalpages ?? 1,
				currentPage: media?.pagination?.currentpage ?? 1,
			};
			state.media.hash = media?.hash;
		});
		builder.addCase(getUserProfileMain.rejected, (state) => {
			state.gallery.loading = false;
			state.gallery.loaded = false;
			state.media.loading = false;
			state.media.loaded = false;
		});
		builder.addCase(getUserProfileMedia.pending, (state) => {
			state.media.loading = true;
		});
		builder.addCase(getUserProfileMedia.fulfilled, (state, action) => {
			if (action.payload.infinityScroll) {
				const newMedia = [
					...state.media.data,
					...(action.payload.media ?? []),
				];

				const newMediaFiltered = newMedia.filter((val, id) => {
					return id === newMedia.findIndex((el) => el.id === val.id);
				});

				state.media.data = newMediaFiltered;
			} else {
				state.media.data = action.payload.media ?? [];
			}

			state.media.loading = false;
			state.media.loaded = true;
			state.media.total = action.payload?.total ?? 0;
			state.media.pagination = {
				totalPages: action.payload?.pagination?.totalpages ?? 1,
				currentPage: action.payload?.pagination?.currentpage ?? 1,
			};
			state.media.hash = action.payload?.hash;
		});
	},
});

// ############################################################

export default userProfileMainContentSlice.reducer;

// ############################################################
